import { render, staticRenderFns } from "./CampanasQr.vue?vue&type=template&id=287fa964&scoped=true"
import script from "./CampanasQr.vue?vue&type=script&lang=js"
export * from "./CampanasQr.vue?vue&type=script&lang=js"
import style0 from "./CampanasQr.vue?vue&type=style&index=0&id=287fa964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@6.26.3_css-loader@6.11.0_webpack_803fd858e391fe10e6ea2ea3dda7e9cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287fa964",
  null
  
)

export default component.exports